import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  Font,
  Image,
  StyleSheet,
  PDFViewer,
} from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { formatToCNPJ, formatToCPF, formatToString } from 'Utils/format';
import { handleAddressNumberOutput } from 'Utils/commons/address';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    padding: 32,
  },
  title: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 100,
  },
  subtitle: {
    marginTop: 5,
    textAlign: 'center',
    fontSize: 10,
    fontWeight: 'bold',
  },
  info: {
    fontSize: 12,
    paddingVertical: 10,
    textDecoration: 'underline',
  },
  upper: {
    textTransform: 'uppercase',
  },
  table: {
    width: '100%',
    borderTop: '1px solid #000',
    borderRight: '1px solid #000',
    fontSize: 10,
  },
  table_row: {
    display: 'flex',
    flexDirection: 'row',
  },
  bold: {
    fontWeight: 'bold',
  },
  row: {
    borderBottom: '1px solid #000',
    borderLeft: '1px solid #000',
    padding: 4,
  },
  align_left: {
    textAlign: 'left',
  },
  align_right: {
    textAlign: 'right',
  },
  align_center: {
    textAlign: 'center',
  },
  bg_gray: {
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
  section_image: {
    textAlign: 'center',
    width: '100%',
  },
  image: {
    width: 150,
    height: 80,
    marginHorizontal: 'auto',
  },
  line1: {
    height: 10,
    width: '100%',
  },
  term: {
    fontSize: 10,
    display: 'flex',
    flexDirection: 'row',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    bottom: 10,
    left: 32,
    textAlign: 'center',
    color: 'grey',
  },
  signature: {
    fontSize: 12,
    marginTop: 52,
  },
});

const PDFTerm = ({ data, products }) => {
  const addressDelivery = data.addresses.find((x) => x.type === 1);

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <View fixed>
          <Text style={styles.title}>PROGRAMAS DE LEALDADE - ACESSA</Text>
          <Text style={styles.subtitle}>
            TERMO DE SOLICITAÇÃO DE RESGATE DE PONTOS
          </Text>
        </View>

        <View style={styles.line1} />

        <View style={styles.section_image}>
          <Image
            src={
              'https://vertice-ds.s3.amazonaws.com/Assets/Images/logotipo/acessa-agro-logo-pdf.png'
            }
            style={styles.image}
          />
        </View>

        <View style={styles.line1} />

        <View style={[styles.table, { width: '50%' }]}>
          <View style={styles.table_row}>
            <Text style={[styles.row, styles.bold, { width: '15%' }]}>
              DATA
            </Text>
            <Text style={[styles.row, { width: '20%' }]}>
              {format(new Date(), 'dd/MM/yyyy')}
            </Text>
            <Text style={[styles.row, styles.bold, { width: '15%' }]}>PMO</Text>
            <Text style={[styles.row, { width: '50%' }]}>
              {data.managerName}
            </Text>
          </View>
          <View style={styles.table_row}>
            <Text style={[styles.row, styles.align_center, { width: '35%' }]}>
              ( )
            </Text>
            <Text style={[styles.row, styles.bold, { width: '65%' }]}>
              INTERMEDIADO?
            </Text>
          </View>
        </View>

        <View style={styles.line1} />

        <View style={[styles.table, { width: '100%' }]}>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              Solicitação
            </Text>
            <Text style={[styles.row, { width: '65%' }]}>#{data.id}</Text>
          </View>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              SEGMENTO
            </Text>
            <Text style={[styles.row, { width: '65%' }]}></Text>
          </View>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.bg_gray,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              Programa
            </Text>
            <Text style={[styles.row, styles.bg_gray, { width: '65%' }]}>
              ACESSA AGRO
            </Text>
          </View>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.bg_gray,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              Participante
            </Text>
            <Text style={[styles.row, styles.bg_gray, { width: '65%' }]}>
              {data.participantName}
            </Text>
          </View>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              CPF/CNPJ
            </Text>
            <Text style={[styles.row, { width: '65%' }]}>
              {data.user.documentNumber.length > 11
                ? formatToCNPJ(data.user.documentNumber)
                : formatToCPF(data.user.documentNumber)}
            </Text>
          </View>
          <View style={styles.table_row}>
            <Text
              style={[
                styles.row,
                styles.align_right,
                styles.upper,
                styles.bold,
                { width: '35%' },
              ]}
            >
              Saldo de pontos
            </Text>
            <Text style={[styles.row, { width: '65%' }]}>
              {formatToString(data.balance.pointsValue)}
            </Text>
          </View>
        </View>

        <View>
          <View style={styles.line1} />
          <Text style={[styles.info, styles.upper]}>
            Serviço ou material solicitado
          </Text>
          <View style={[styles.table, { width: '100%' }]}>
            <View style={styles.table_row}>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '5%' },
                ]}
              >
                Qtd.
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '10%' },
                ]}
              >
                Unid.
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '30%' },
                ]}
              >
                Item
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '18%' },
                ]}
              >
                Valor unitário Pts
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '10%' },
                ]}
              >
                Espec. I
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '10%' },
                ]}
              >
                Espec. II
              </Text>
              <Text
                style={[
                  styles.row,
                  styles.bg_gray,
                  styles.align_right,
                  styles.upper,
                  styles.bold,
                  { width: '17%' },
                ]}
              >
                Valor total Pts
              </Text>
            </View>
            {products.map((product) => {
              return (
                <View style={styles.table_row}>
                  <Text style={[styles.row, { width: '5%' }]}>
                    {formatToString(product.quantity)}
                  </Text>
                  <Text style={[styles.row, { width: '10%' }]}>Unidade(s)</Text>
                  <Text style={[styles.row, { width: '30%' }]}>
                    {product.name}
                  </Text>
                  <Text
                    style={[styles.row, styles.align_right, { width: '18%' }]}
                  >
                    {formatToString(
                      data.type === 3
                        ? product.unitPrice
                        : product.unitPointsPrice
                    )}
                  </Text>
                  <Text style={[styles.row, { width: '10%' }]}></Text>
                  <Text style={[styles.row, { width: '10%' }]}></Text>
                  <Text
                    style={[styles.row, styles.align_right, { width: '17%' }]}
                  >
                    {formatToString(
                      data.type === 3
                        ? product.unitPrice * product.quantity
                        : product.unitPointsPrice * product.quantity
                    )}
                  </Text>
                </View>
              );
            })}
          </View>
        </View>

        <View wrap={false}>
          <View style={styles.line1} />
          <View style={[styles.table, { width: '100%' }]}>
            <View style={styles.table_row}>
              <Text
                style={[
                  styles.row,
                  styles.bold,
                  styles.upper,
                  styles.align_right,
                  { width: '75%' },
                ]}
              >
                Valor final em pontos
              </Text>
              <Text style={[styles.row, styles.align_right, { width: '25%' }]}>
                {formatToString(
                  data.type === 3 ? data.totalPrice : data.totalPoints
                )}
              </Text>
            </View>
          </View>
        </View>

        <View wrap={false}>
          <View style={styles.line1} />
          <Text style={[styles.info, styles.upper]}>Observações</Text>
          <View style={[styles.table, { width: '100%' }]}>
            <View style={styles.table_row}>
              <Text
                style={[
                  styles.row,
                  styles.align_right,
                  styles.bold,
                  styles.upper,
                  { width: '30%' },
                ]}
              >
                Endereço de entrega com CEP
              </Text>
              <View style={[styles.row, { width: '70%' }]}>
                <Text>{`${addressDelivery.address}, ${handleAddressNumberOutput(addressDelivery.number)}, ${addressDelivery.neighborhood}, ${addressDelivery.city}, ${addressDelivery.state} - ${addressDelivery.zipCode}`}</Text>
                <Text>{`${addressDelivery.complement}`}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.line1} />
        <View style={[styles.term]}>
          <Text>
            {' '}
            <Text style={[styles.upper, styles.bold, { paddingRight: 10 }]}>
              Estou ciente / autorizo:
            </Text>{' '}
            <Text style={{ marginLeft: 8 }}>
              (i) Resgatar o montante de pontuação acima indicada (Valor Total
              PTS) para a entrega dos serviços e/ou materiais (ITEM) solicitados
              e pelo fornecedor por mim escolhidos; (ii) A desistência do
              resgate após a assinatura do presente termo implica na não
              devolução dos pontos; (iii) Os materiais resgatados como EPIs,
              uniformes, equipamentos, maquinários e outros possuem o logotipo
              do programa e da Syngenta adesivados, impressos ou estampados;
              (iv) Nos programas educacionais e/ou viagens nos quais não houver
              formação de turma mínima, os pontos resgatados serão devolvidos em
              sua totalidade ao participante; (v) Em caso de resgates de eventos
              e ou outras atividades externas é de exclusiva e integral
              responsabilidade do participante zelar pela sua própria segurança
              em todos os aspectos e não se expor a atividades de risco de
              quaisquer fins; (vi) A Syngenta não se responsabiliza pela
              eficácia, funcionamento, efetividade ou qualquer outra
              característica técnica dos serviços, mercadorias ou equipamentos
              fornecidos, sendo estas de exclusiva e integral responsabilidade
              do fornecedor escolhido; e (vii) Alguns resgates e/ou eventos
              possuem serviço de fotografia e filmagem, ficando desde já
              expressamente autorizada pelo participante, a título gratuito e
              por prazo de até 24 meses,a utilização de sua imagem e som de voz
              pela Syngenta exclusivamente captadas em tais resgates e/ou
              eventos, em todos e quaisquer meios de comunicação definidos pela
              Syngenta; (viii) Em caso de incidência de DIFAL sobre o resgate de
              produtos no catálogo de prêmios, o custeio dessa taxa é de
              responsabilidade do participante.
            </Text>
          </Text>
        </View>

        <View style={styles.signature}>
          <View
            style={{
              borderTop: '1px solid #000',
              width: '50%',
              marginBottom: 6,
            }}
          ></View>
          <Text style={styles.upper}>{data.participantName}</Text>
          <Text>
            CPF/CNPJ:{' '}
            {data.user.documentNumber.length > 11
              ? formatToCNPJ(data.user.documentNumber)
              : formatToCPF(data.user.documentNumber)}
          </Text>
          <Text>{format(new Date(), 'dd/MM/yyyy')}</Text>
        </View>

        <Text
          style={[styles.pageNumber, styles.upper]}
          render={({ pageNumber, totalPages }) =>
            `Página ${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PDFTerm;
